module.exports = __webpack_public_path__ + "img/btn4.24c8be71.gif";